
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from "../layouts/main";
import Loader from "../components/common/Loader";
import useTranslation from "next-translate/useTranslation";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
const HowToBuy = () => {
    const { t } = useTranslation();
    const how_to_buy = t('how_to_buy:data', {}, { returnObjects: true });
    const seo = t('common:seo', {}, { returnObjects: true });
    const [isView, setIsView] = useState({
        view: false,
        url: ''
    });
    const [date, setDate] = useState('');
    const [origin, setOrigin] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        setOrigin(window.location.origin);
        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 2000, true);
        });
        Promise.all([appLoading]).then(values => {
            setIsLoading(false);
            setLoaded(true);
        });
        setDate(new Date().toLocaleDateString());
    }, []);
    return (<MainLayout title={seo.how_to_buy.title} description={seo.how_to_buy.description} keywords={seo.how_to_buy.keywords} page={'home'} alternate={'how-to-buy'} loaded={loaded}>
            <div className='banner_bg'>
                <Header t={t}/>
            </div>
            <main className='main'>
                <section className={`how_to_buy_section`}>
                    <div className="container">
                        <div className="how_to_buy_section_wrapper">
                            <div className='list_category post'>
                                <div className='post_head'>
                                    <img alt={'GoodEgg education center'} src={'/img/small_logo.svg'} className='post_head_img'/>
                                    <div className='post_head_info'>
                                    <h4>GoodEgg</h4>
                                        <span>{date}</span>
                                    </div>
                                </div>
                                <div className='post_share'>
                                    <h5>{how_to_buy.body.share}</h5>
                                    <div className='post_share_icons'>

                                        <a href={encodeURI(`https://t.me/share/url?url=${origin}/how-to-buy&text=How To Buy $GEGG Tokens`)}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#fff"/>
                                                <path d="M4.16184 9.91329L10.8959 7.13873C11.5607 6.84971 13.815 5.92486 13.815 5.92486C13.815 5.92486 14.8555 5.52023 14.7688 6.50289C14.7399 6.90751 14.5087 8.3237 14.2774 9.85549L13.5549 14.3931C13.5549 14.3931 13.4971 15.0578 13.0058 15.1734C12.5144 15.289 11.7052 14.7688 11.5607 14.6532C11.4451 14.5665 9.39305 13.2659 8.64161 12.6301C8.4393 12.4566 8.20808 12.1098 8.67051 11.7052C9.71097 10.7514 10.9537 9.56647 11.7052 8.81503C12.052 8.46821 12.3988 7.65896 10.9537 8.64162L6.8786 11.3873C6.8786 11.3873 6.41618 11.6763 5.54912 11.4162C4.68207 11.1561 3.67051 10.8092 3.67051 10.8092C3.67051 10.8092 2.97687 10.3757 4.16184 9.91329Z" fill="#191919"/>
                                            </svg>
                                        </a>
                                        <a href={`https://twitter.com/intent/tweet?url=${origin}/how-to-buy`}>
                                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.422 1.20733C19.1383 2.15135 18.5577 2.86604 17.7469 3.41539C18.1349 3.39405 18.5068 3.30605 18.8788 3.20738C19.2534 3.10871 19.612 2.97004 20 2.81537C19.8662 3.04738 19.719 3.22872 19.5718 3.41005C19.133 3.9514 18.6353 4.43141 18.0706 4.84476C17.993 4.90076 17.9663 4.9621 17.969 5.05543C18.0305 8.18618 17.011 10.9356 14.9719 13.3037C13.8025 14.661 12.3629 15.6637 10.6877 16.3171C9.08215 16.9438 7.41236 17.1864 5.69173 17.1064C4.05673 17.0318 2.50736 16.6237 1.04094 15.9011C0.682366 15.7251 0.331817 15.5304 0 15.2984C1.07038 15.4024 2.12202 15.3197 3.15761 15.0344C4.19588 14.7464 5.13781 14.2744 6.02355 13.597C5.84426 13.5783 5.69976 13.5677 5.55793 13.5463C4.35644 13.365 3.40915 12.781 2.71341 11.789C2.51539 11.5063 2.36018 11.2023 2.24512 10.8796C2.19695 10.7436 2.20498 10.7329 2.34948 10.7569C2.86326 10.8449 3.37169 10.8183 3.87744 10.7063C3.9042 10.7009 3.92829 10.6956 3.95504 10.6876C3.9604 10.6849 3.96575 10.6743 3.97645 10.6583C3.83998 10.6183 3.70351 10.5809 3.56971 10.5382C1.94006 10.0102 0.767996 8.43419 0.75194 6.75148C0.749264 6.59414 0.749264 6.59414 0.893765 6.66614C1.37276 6.90882 1.87851 7.05015 2.4137 7.09549C2.44849 7.09816 2.48595 7.09815 2.52074 7.09815C2.52877 7.09815 2.53679 7.09015 2.54482 7.08482C2.54482 7.03415 2.49666 7.02615 2.46722 7.00482C0.816163 5.79679 0.305057 3.56206 1.27375 1.76201C1.34332 1.63134 1.346 1.63134 1.43698 1.74067C2.58229 3.09805 3.96307 4.14874 5.58202 4.88743C6.67648 5.38611 7.82446 5.70612 9.02061 5.84479C9.24539 5.87145 9.47284 5.88479 9.7003 5.90879C9.81001 5.92212 9.82606 5.88745 9.80466 5.78345C9.47552 4.11674 10.198 2.43136 11.627 1.52467C13.2539 0.495307 15.3572 0.711313 16.7353 2.06068C16.837 2.15935 16.9253 2.16202 17.0431 2.13535C17.8485 1.94868 18.6112 1.66067 19.3283 1.25533C19.3605 1.23933 19.3899 1.22333 19.422 1.20733Z" fill="#fff"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className={`how_to`}>
                                <h2 className='how_to_title'>{how_to_buy.body.title}</h2>
                                <ul className='how_to_items'>
                                    {how_to_buy.body.items.map(el => {
            return <li className={'how_to_item'} key={el.title}>
                                            <div className="how_to_item_img">
                                                <picture>
                                                    <source media="(max-width: 576px)" srcSet={`/img/how_to/${el.img.url}.webp`} type="image/webp"/>
                                                    <source media="(min-width: 577px)" srcSet={`/img/how_to/${el.img.url}_x2.webp`} type="image/webp"/>
                                                    <source media="(max-width: 576px)" srcSet={`/img/how_to/${el.img.url}.png`}/>
                                                    <source media="(min-width: 577px)" srcSet={`/img/how_to/${el.img.url}_x2.png`}/>
                                                    <img src={`/img/how_to/${el.img.url}.png`} alt="GoodEgg How To" width={el.img.w} height={el.img.h} className='item_img'/>
                                                </picture>
                                                <img src={`/img/how_to/resize.png`} alt="GoodEgg How To" width={176} height={176} className='resize' onClick={() => {
                    setIsView({ view: true, url: el.img.url });
                }}/>
                                            </div>
                                            <div data-number={el.step} className='how_to_item_desc'>
                                                <h3>{el.title}</h3>
                                                <p>{el.description}</p>
                                            </div>
                                        </li>;
        })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
            <div className={`full_view ${isView.view ? 'show' : ''}`}>
                <div className="full_view_content">
                    <svg onClick={() => {
            setIsView({
                view: false, url: ''
            });
        }} className='full_view_content_close' xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <g opacity="0.5">
                            <path d="M1.29785 1L10.3012 10L1.29785 19" stroke="#191919" strokeWidth="2"/>
                            <path d="M19.3047 19L10.3013 10L19.3047 0.999998" stroke="#191919" strokeWidth="2"/>
                        </g>
                    </svg>
                    {isView.view ? <img src={`/img/how_to/${isView.url}_x3.png`} alt="GoodEgg How To" width={''} height={''} className='item_img'/> : 'No Data To Show'}
                </div>
            </div>
        </MainLayout>);
};
export default HowToBuy;

    async function __Next_Translate__getStaticProps__192c28627c6__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/how-to-buy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__192c28627c6__ as getStaticProps }
  